module.exports = __webpack_public_path__ + "static/media/favicon-195.d3c0e1e2.png";